<template>
  <div>
    <van-sticky :offset-top="46" @scroll="handleScrollStatus">
      <van-search
        v-model="queryParams.productName"
        shape="round"
        show-action
        background="#4fc08d"
        clearable
        placeholder="请输入搜索关键词"
      >
        <template #action>
          <div style="padding: 0px 4px;" @click="handleRefresh">搜索</div>
        </template>
      </van-search>
    </van-sticky>
    <page-list ref='pageList' request-url="/purchase" :getParams="getQueryParams">
      <template #row="{row}">
        <div style="background-color:rgba(172,201,220,0.19);line-height: 32px;border-radius: 6px;padding: 6px 10px">
        <van-row>
          <van-col span="24">商品名称: {{row.productName}}</van-col>
          <van-col span="12">数量: {{row.quantity}} ({{row.unit}})</van-col>
          <van-col span="12">参考价: {{row.referencePrice|| '0'}} (元/{{row.unit}})</van-col>
        </van-row>
        <van-row type="flex" justify="center" >
          <van-col span="12"><van-button type="info" size="small" block @click="openOutDrawer(row)">编辑</van-button></van-col>
          <van-col span="12"><van-button type="default" size="small" block @click="openScrapDrawer(row)">完成</van-button></van-col>
        </van-row>
        </div>
      </template>
    </page-list>
    <van-submit-bar >
      <template #button>
        <van-button  round block @click="openSettingRatioDrawer">采购履历</van-button>
        <van-button type="primary" round block @click="batchChangePrice">添加计划</van-button>
      </template>
    </van-submit-bar>
    <down-drawer ref='purchaseDrawer' @close="handleRefresh" @confirm="adjustPurchaseInfo" title="调整采购信息" >
      <template #content>
        <van-form ref="form" :validate-first="true" :show-error-message="false">
          <van-field
            name="purchasePrice"
            label="采购单价"
            input-align ='right'
            :rules="[{ required: true, message: '采购单价不能为空' }]">
            <template #input>
              <van-stepper v-model="model.purchasePrice" step="0.1" :decimal-length="2" :input-width ='64' :min="0.1"/>
            </template>
          </van-field>
          <van-field
            name="purchaseQuantity"
            label="采购数量"
            input-align ='right'
            :rules="[{ required: true, message: '采购数量不能为空' }]">
            <template #input>
              <van-stepper v-model="model.purchaseQuantity" step="0.1" :decimal-length="2" :input-width ='64' :min="0.1"/>
            </template>
          </van-field>
        </van-form>
      </template>
    </down-drawer>
    <van-calendar v-model="show" :show-confirm="false" @confirm="onDeliveryDateConfirm" :min-date="minDate" :style="{ height: '500px' }"/>
  </div>
</template>

<script>
import PageList from '@/components/tools/PageList'
export default {
  name: 'PurchaseList',
  components: { PageList },
  created () {
    this.queryParams.deliveryDate = this.$moment(new Date()).format('YYYY-MM-DD')
    this.statistics.deliveryDate = this.$moment(new Date()).format('YYYY-MM-DD')
    // 获取当前配送日期的采购信息
    this.getPurchaseStatistics()
  },
  data () {
    const that = this
    return {
      url: {
        imgerver: window._CONFIG.staticDomainUrl
      },
      purchaseVisible: false,
      show: false,
      allOrder: false,
      model: {},
      queryParams: {
        purchaseStatus: -1,
        deliveryDate: '',
        productName: null

      },
      statistics: {
        deliveryDate: '',
        purchaseTotalAmount: 0.00,
        waitPurchaseQuantity: 0,
        confirmPurchaseQuantity: 0
      },
      minDate: new Date(that.$moment(new Date()).subtract(1, 'months').startOf('month').format('YYYY-MM-DD')),
      option: [
        { text: '全部采购单', value: -1 },
        { text: '待采购', value: 0 },
        { text: '已采购', value: 1 }
      ]
    }
  },
  computed: {

  },
  methods: {
    openAdjustPurchase (row) {
      this.model = {}
      this.$refs.purchaseDrawer.show = true
      this.model.purchaseId = row.id
      this.model.purchasePrice = row.purchasePrice
      this.model.purchaseQuantity = row.purchaseQuantity
    },
    adjustPurchaseInfo () {
      if (!this.model.purchasePrice || isNaN(this.model.purchasePrice)) {
        this.$toast.fail('无效的采购单价')
        return
      }
      if (!this.model.purchaseQuantity || isNaN(this.model.purchaseQuantity)) {
        this.$toast.fail('无效的采购数量')
        return
      }
      // 触发表单验证
      this.$refs.form.validate().then(() => {
        this.$api.shop.updatePurchaseInfo(this.model.purchaseId, {
          purchasePrice: this.model.purchasePrice,
          purchaseQuantity: this.model.purchaseQuantity
        }).then(response => {
          if (response.success) {
            this.$toast.success('操作成功')
            this.$refs.purchaseDrawer.show = false
          } else {
            this.$toast.fail(response.message)
          }
        }).catch(() => {
        })
      }).catch((err) => {
        console.log('验证失败', err)
      })
    },
    getQueryParams (params) {
      const param = Object.assign({}, params)
      if (this.queryParams.purchaseStatus !== -1) {
        param.purchaseStatus = this.queryParams.purchaseStatus
      }
      param.deliveryDate = this.queryParams.deliveryDate
      param.productName = this.queryParams.productName
      return { params: param }
    },
    handleRefresh () {
      this.$refs.pageList.onRefresh(20, false)
      // 获取当前配送日期的采购信息
      this.getPurchaseStatistics()
    },
    getPurchaseStatistics () {
      this.$api.shop.getPurchaseStatistics(this.queryParams.deliveryDate).then(response => {
        if (response.success) {
          this.statistics = response.result
        }
      }).catch(() => {
      })
    },
    onDeliveryDateConfirm (date) {
      this.show = false
      this.queryParams.deliveryDate = this.$moment(date).format('YYYY-MM-DD')
      this.$refs.item.toggle()
      this.handleRefresh()
    },
    handleScrollStatus (e) {
      // console.log(JSON.stringify(e))
      // if (e.isFixed === false) {
      //   this.$toast.success(JSON.stringify(e))
      // }
    }

  }
}
</script>

<style lang="less" scoped>
  .avatar{
    width: 84px;
    height: 84px;
    vertical-align: middle;
    padding: 8px 0px;
    border-radius: 50%;
  }
  .profit {
    color: #07c160;
  }
  .loss {
    color: #ee0a24;
  }
  .warn {
    color: #ed8b08
  }
</style>
